<iframe [src]="viewerUrl" width="100%" height="100%" [frameBorder]="0"></iframe>
